var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.746582,
    y: 0.650879,
    width: 64.3944,
    height: 64,
    rx: 20,
    fill: "#01C2F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5129_5943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4282 15.2229C39.4595 15.6291 40.7798 17.6057 40.3735 19.6369L40.1938 20.5275C39.7798 22.6135 39.0142 24.5979 37.9438 26.4025H49.1938C51.2642 26.4025 52.9438 28.0822 52.9438 30.1525C52.9438 31.5979 52.1235 32.8557 50.9204 33.4807C51.772 34.1682 52.3188 35.2229 52.3188 36.4025C52.3188 38.2307 51.0063 39.7541 49.2798 40.0822C49.6235 40.6525 49.8188 41.3166 49.8188 42.0275C49.8188 43.6916 48.7329 45.1057 47.2329 45.59C47.2876 45.8479 47.3188 46.1213 47.3188 46.4025C47.3188 48.4729 45.6392 50.1525 43.5688 50.1525H35.9517C34.4673 50.1525 33.022 49.715 31.7876 48.8947L28.7798 46.8869C26.6938 45.4963 25.4438 43.1525 25.4438 40.6447V37.6525V33.9025V31.9572C25.4438 29.676 26.4829 27.5275 28.2563 26.0979L28.8345 25.6369C30.9048 23.9807 32.3188 21.6525 32.8345 19.0588L33.0142 18.1682C33.4204 16.1369 35.397 14.8166 37.4282 15.2229ZM15.4438 27.6525H20.4438C21.8267 27.6525 22.9438 28.7697 22.9438 30.1525V47.6525C22.9438 49.0354 21.8267 50.1525 20.4438 50.1525H15.4438C14.061 50.1525 12.9438 49.0354 12.9438 47.6525V30.1525C12.9438 28.7697 14.061 27.6525 15.4438 27.6525Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5129_5943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12.9438 12.6509)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.761288ae7d63892bd12ad96258f66b2c.svg";
export { ForwardRef as ReactComponent };